<div class="euromillones-play-core-wrapper">

  @if (device === devices.DESKTOP) {
    <app-puntos-venta-desktop></app-puntos-venta-desktop>
  }

  @if (device === devices.MOBILE) {
    <app-puntos-venta-mobile></app-puntos-venta-mobile>
  }

</div>